/*
 * @Description: 
 * @Author: jiangdongdong@mininglamp.com
 * @Date: 2024-12-18 10:43:57
 */
/**
 * 基本布局
 */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Layout } from 'antd';
import MicroApp from '@/config/micro-app';
import useGlobalState from '@/hooks/useGlobalState';
import useInitMedia from '@/hooks/useInitMedia';
import { MICRO_APP_INSTANCE } from '@/config/index';
import { TActionTypeEnum,TGlobalState } from '@/types/global';
import '@/styles/index.less';
import MainHeader from './MainHeader';
import MainFooter from "./MainFooter";
const { Content } = Layout;

const BasicLayout = ({ route, children }: any) => {
  const dispatch = useDispatch();
  const { isLogin, currentUser, currentNetworkId, currentCampaignId,medias,configMedias,configMediaAdTypes,configMediaCodes, getSession ,setCurrentNetworkId,setCurrentCampaignId
  } = useGlobalState();
  //获取用户基本信息
  useEffect(() => {
    getSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 初始化media
  useInitMedia({ isLogin });
  //注册并启动子应用
  useEffect(() => {
    if (!isLogin || !currentNetworkId || medias?.length===0) return;
    // 已经注册过了,直接返回
    if (window[MICRO_APP_INSTANCE]){
      const state = { currentNetworkId: currentNetworkId, currentUser: currentUser, currentCampaignId: currentCampaignId,configMedias:configMedias,configMediaAdTypes:configMediaAdTypes,configMediaCodes:configMediaCodes,setCurrentNetworkId,setCurrentCampaignId};
      window[MICRO_APP_INSTANCE]?.actions.setGlobalState(state)
      return;
    };
    const microApp = new MicroApp({
      host: window.location.host,
      state: { currentNetworkId: currentNetworkId, currentUser: currentUser, currentCampaignId: currentCampaignId,configMedias:configMedias,configMediaAdTypes:configMediaAdTypes,configMediaCodes:configMediaCodes,setCurrentNetworkId,setCurrentCampaignId},
    });
    window[MICRO_APP_INSTANCE] = microApp;
    microApp.register();
    microApp.start();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin, currentNetworkId,currentCampaignId,medias])

  // 监听由子应用触发的状态改变
  useEffect(()=>{
    if(!window[MICRO_APP_INSTANCE])return;
    window[MICRO_APP_INSTANCE]?.actions.onGlobalStateChange((newState: TGlobalState) => {
      console.log('修改主应用状态newState===',newState)
      // 修改主应用状态
      dispatch({
        type: TActionTypeEnum.SET_BY_QIANKUN,
        payload: newState as TGlobalState,
      });
    });
  },[dispatch]);

  return (
    <Layout style={{ minHeight: '100vh',paddingTop: '58px' }}>
      <MainHeader routes={route.childRoutes} />
      <div id="subappView">
        <Content>
          {children}
        </Content>
      </div>

      <MainFooter />
    </Layout>
  )
};

export default BasicLayout;